/**
 * @generated SignedSource<<3a711988cdce0999d5c96e56796cade9>>
 * @relayHash 2dd0683e5c8c8023476603b9c599eed0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e9580ee86745fc1be5c2ccc60ce1457d3072d1458995c13fa9b1896f48d6c776

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentBrowseIntentsQuery } from './VirtualAgentBrowseIntentsQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentBrowseIntentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e9580ee86745fc1be5c2ccc60ce1457d3072d1458995c13fa9b1896f48d6c776",
    "metadata": {},
    "name": "VirtualAgentBrowseIntentsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
